export const COMMON_INPUT_CLASS =
	"border border-gray-300 rounded-lg focus-visible:border-purple-400 aria-[invalid=true]:border-red-300 focus:outline outline-4 outline-purple-50 aria-[invalid=true]:outline-red-100";
export const COMMON_BORDERLESS_CLASS = "outline-0";
